import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import intl from 'react-intl-universal';
import { Tooltip } from 'antd';
import { store } from 'Store/store.index';
import './DocOrigin.scss';

@inject('docStore')
@observer
class DocOrigin extends Component {
    constructor(props) {
        super(props);
    }
    
    render () {
        let docDriveName = store.docStore.docDriveName; // local, box, dropBox, googleDrive, iManage, oneDrive
        const { withText = false } = this.props;
        switch (docDriveName) {
            case 'Google Drive': 
                docDriveName = 'googleDrive';
                break;
            case 'OneDrive': 
                docDriveName = 'oneDrive';
                break;
            case 'Box': 
                docDriveName = 'box';
                break;
            case 'DropBox': 
                docDriveName = 'dropBox';
                break;
            case 'iManage': 
                docDriveName = 'iManage';
                break;
            case 'SharePoint': 
                docDriveName = 'sharePoint';
                break;
            case 'Storage': 
                docDriveName = 'storage';
                break;
            default: 
                docDriveName = 'local';
                break;
        }
        return (<>
            {withText ? (
              <>
                  <i className={`doc-origin doc-or-icon-item color_${docDriveName}`}></i>
                  <span className="doc-origin-text">{intl.get('HeaderContainer.Origin.' + docDriveName)}</span>
              </>
            ) : (
              <Tooltip title={intl.get('HeaderContainer.Origin.' + docDriveName)}>
                  <i className={`doc-origin ${docDriveName}`}></i>
              </Tooltip>
            )}
        </>);
    }
}

export default DocOrigin;
